import { App, Button, Popover, Spin } from "antd";
import { fetchCustomerCsv } from "./queries";

const ExportButton = ({ isLoading, setLoadingComponent }) => {
  const { notification } = App.useApp();
  return (
    <Popover
      title="Datenbank exportieren"
      content={<div>Erhalten Sie eine csv-Datei mit allen Kundendaten.</div>}
    >
      <Button
        onClick={() => fetchCustomerCsv(notification, setLoadingComponent)}
        disabled={isLoading.export || isLoading.delete || isLoading.import}
      >
        {isLoading.export ? (
          <div>
            <Spin /> Exportiere...
          </div>
        ) : (
          "Kundendaten exportieren"
        )}
      </Button>
    </Popover>
  );
};
export default ExportButton;
